import { autotraceItemFields } from '@/pages/autotrace/models/autotrace-fields'
import { allBlockchainCoin, allTokensItem } from '@/assets/static/currency-list'

export default {
  showCreateEditModal: false,
  modalAction: 'create',
  createEditModalData: autotraceItemFields(),
  activeBlockchain: allBlockchainCoin,
  activeToken: allTokensItem,
  activeSearchField: '',
  caseActiveTab: '',
  caseInfo: {},
  checkedAlertsMap: {},
  checkedAlertsCount: 0,
  entityIconCache: {},
  reloadAutotraceCaseTrigger: null,
  clearTrigger: false,
}
